import { createElement } from 'react';
import { TableInternalControls } from '../components/TableSortControls';
import type { MRT_ColumnDef, MRT_TableOptions } from 'mantine-react-table';

import type { Options } from './types';

/** Mantine Select: match typed text against option labels only (not UUID values). */
export function filterSelectByLabel(value: string, item: Options): boolean {
  return (item.label ?? '').toLowerCase().includes(value.toLowerCase().trim());
}

export function withMrtContainsSearch<T extends Record<string, unknown>>(
  options: MRT_TableOptions<T>,
): MRT_TableOptions<T> {
  return {
    globalFilterFn: 'contains',
    ...options,
    mantineTopToolbarProps: args => {
      const props=typeof options.mantineTopToolbarProps==='function'
        ? options.mantineTopToolbarProps(args) : options.mantineTopToolbarProps;
      return {...props,className:[props?.className,'app-table-toolbar'].filter(Boolean).join(' ')};
    },
    renderToolbarInternalActions: options.renderToolbarInternalActions ?? (({table}) => createElement(TableInternalControls<T>, {table})),
    defaultColumn: {
      filterFn: 'contains',
      enableGlobalFilter: false,
      ...options.defaultColumn,
    },
    initialState: {
      globalFilterFn: 'contains',
      ...options.initialState,
    },
  };
}

/** Enable toolbar global search only on the listed column ids / accessorKeys. */
export function enableGlobalSearchOnColumns<T extends Record<string, unknown>>(
  columns: MRT_ColumnDef<T>[],
  searchableColumnIds: string[],
): MRT_ColumnDef<T>[] {
  const allowed = new Set(searchableColumnIds);
  return columns.map((column) => {
    const columnId = String(column.accessorKey ?? column.id ?? '');
    return {
      ...column,
      enableGlobalFilter: allowed.has(columnId),
    };
  });
}
